import { ActionReducer } from '@ngrx/store';
import { RequestStatus, RequestStatusAction } from '../../actionstypes/request-status/request-status.actiontype';

const initialState: RequestStatus = {
  isLoaded: false,
  isError: false,
  error: null,
};

export default (requestLoadType: string, requestSuccessType: string, requestErrorType: string): ActionReducer<RequestStatus> => {
  return (state: RequestStatus = initialState, action: RequestStatusAction) => {
    switch (action.type) {
      case requestLoadType:
        return {
          isLoaded: false,
          isError: false,
          error: null,
        };

      case requestSuccessType:
        return {
          isLoaded: true,
          isError: false,
          error: null,
        };

      case requestErrorType:
        return {
          isLoaded: true,
          isError: true,
          error: action.error || null,
        };

      default:
        return state;
    }
  };
};
